export default __webpack_public_path__ + "static/media/VANTEC20AARRAYr.fbd9f8e6.png";